import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: 105px calc(100% - 130px);
  grid-gap: 25px;
`;
